"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagEG = function FlagEG(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M216.6-32.55H-193v-82.39a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.07,7.07,0,0,1-193,139.3V56.91H216.6V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "90.45",
    width: "409.6",
    height: "89.44",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M34.35-1.77A5.12,5.12,0,0,0,27.6-6.63L21.35-4.55l-1.51-9.16A11.24,11.24,0,0,0,8.71-23.13H2.87l-6.1,7.52H4.85L2.59-4.43-4-6.63a5.13,5.13,0,0,0-6.75,4.87v38l9.09-9.09L-5.94,40h-4.81v7.51h45.1V40H29.54L25.26,27.12l9.09,9.09v-38ZM8,40H2L6.15,28.85,8,31.26Zm7.52,0V31.26l1.89-2.41L21.62,40ZM11.8,26.35S.17,18.48.64,3.8A17.73,17.73,0,0,0,11.8-3.72,17.78,17.78,0,0,0,23,3.8C23.43,18.48,11.8,26.35,11.8,26.35Zm0,0",
    transform: "translate(194 123)",
    fill: "#f0c727"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagEG;
exports["default"] = _default;